import DashboardCTA from '../../../dashboardComponents/DashboardCTA/DashboardCTA';
import { Button } from '@iwoca/orion';
import {
    FormattedDate,
    FormattedMessage,
    WrappedComponentProps,
    injectIntl
} from 'react-intl';
import messages from './TopUpApproved.messages';
import { RocketSVG } from '@svgComponents/rocketSVG/RocketSVG';
import { MoneyNoDecimals } from '../../../../../myAccount/ui/moneyNoDecimals';
import styles from '../DashboardActions.module.css';
import { connect } from 'react-redux';
import * as selectors from '../../../accountsSelector';
import { RootState } from '@iwProvider/configureStore';
import { Rate } from '../../../../../myAccount/ui/rate';

const mapStateToProps = (state: RootState) => {
    const productType = selectors.DEProductTypeConversion(
        selectors.getProductTypeFromURL()
    );

    return {
        availableCredit: selectors.getMaxCashAmount(state, productType),
        topUpApprovalTimeOut: selectors.getTimeOutDate(state, productType),
        isPreApproved: selectors.isPreApproved(state, productType),
        interestRate: selectors.getMaxMonthlyInterestRate(state, productType)
    };
};

type PropsFromRedux = ReturnType<typeof mapStateToProps>;

type Props = {
    onCtaClick: () => void;
    className?: string;
} & PropsFromRedux &
    WrappedComponentProps;

const TopUpApproved = ({
    availableCredit,
    topUpApprovalTimeOut,
    isPreApproved,
    onCtaClick,
    className,
    interestRate
}: Props) => {
    return (
        <DashboardCTA
            data-testid="drawdown-topup-action"
            title={<FormattedMessage {...messages.title} />}
            className={className}
            icon={<RocketSVG />}
            description={
                <FormattedMessage
                    {...(isPreApproved
                        ? messages.preApprovedDescription
                        : messages.description)}
                    values={{
                        amount: (
                            <span className={styles.topupApprovedAmount}>
                                <MoneyNoDecimals
                                    value={Math.floor(availableCredit)}
                                />
                            </span>
                        ),
                        interestRate: (
                            <strong>
                                <Rate value={interestRate} />
                            </strong>
                        ),
                        expiryDate: (
                            <span className={styles.topupApprovedExpiryDate}>
                                <FormattedDate
                                    value={new Date(topUpApprovalTimeOut!)}
                                    day="2-digit"
                                    month="short"
                                    year="numeric"
                                />
                            </span>
                        )
                    }}
                />
            }
            cta={
                <Button
                    variant="success"
                    data-testid="drawdown-topup-button"
                    onClick={onCtaClick}
                    className={styles.dashboardActionCTA}
                >
                    <FormattedMessage {...messages.ctaText} />
                </Button>
            }
        />
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(injectIntl(TopUpApproved));
